import {
  CaretDownOutlined,
  ExclamationCircleOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  QuestionCircleTwoTone,
} from '@ant-design/icons'
import { Button, Col, Dropdown, Menu, Popover, Row, Space } from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { EditableColumnType } from '../../../compnents/list/EditableList'
import { BillingCategoryName } from '../../../models/billingCategory'
import {
  getOrderCategoryName,
  getOtcCategoryName,
  Material,
} from '../../../models/material'
import { SkinTestStatus } from '../../../models/treatment'
import { ThemeData } from '../../../theme/ThemeContext'
import styles from './RecipeEditor.module.css'
import bwwxwImg from '../images/bwxwImg.png'
import { ToothComponents } from './modals/toothComponents'
import { Checks } from '../../../models/setting'

const getPayTypeColor = (payType: number) => {
  switch (payType) {
    case 0:
      return '#af623c'
    case 1:
      return '#088f52'
    case 2:
      return '#000000'
    case 3:
      return '#2070d0'
    default:
      return ''
  }
}

// 随访列
export const MedicineSFMaterialColumns = (
  theme: ThemeData,
  materials: Material[],
  settings?: any,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any) => void,
  isShowVisibale?: boolean,
  openEditVisible?: (v: any) => void,
): EditableColumnType<Material>[] => {
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()

  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const PSMenu = (m: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', m)
        }}
      >
        通知皮试
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '续用' })
        }}
      >
        续用
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '免皮' })
        }}
      >
        免皮
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('jgdj', m)
        }}
      >
        结果登记
      </Menu.Item>
    </Menu>
  )

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '6rem',
      render: function Element(_, m) {
        // if (m.state === -1) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '组号',
      width: '3rem',
      dataIndex: 'groupNumber',
      align: 'center',
      render: (text, m) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1,
          },
        }
        const members = groups[m.groupNumber]
        if (members && members.indexOf(m.id) === 0) {
          obj.props.rowSpan = members.length
        } else if (members) {
          obj.props.rowSpan = 0
        }
        return obj
      },
    },
    {
      title: '项目信息',
      key: 'name',
      align: 'left',
      width: '10rem',
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        if (
          m.inventoryInfo ||
          m.unShelveInfo ||
          expiredInDays <= 90 ||
          (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
        ) {
          indicator = theme.e
        } else if (
          m.skinTestTag === SkinTestStatus.NeedATest &&
          m.skinTestInfo
        ) {
          indicator = theme.w
        } else if (
          (m.skinTestTag === SkinTestStatus.Continue ||
            m.skinTestTag === SkinTestStatus.Negative) &&
          m.skinTestInfo
        ) {
          indicator = theme.s
        }

        // 是否单味可能不予支付
        const isDWKNBYZF  = m.memo?.indexOf('单味可能不予支付') >= 0
        const color = m?.state == 5  ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1

        return {
          props: {
            style: {
              maxWidth: 300,
              borderLeft: `4px solid ${indicator}`,
              overflow: 'hidden',
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Col>
                <div
                  className={styles.infoTips}
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                  }}
                >
                  {(m.memo === '□' || m.memo === '◇' || m.memo === '△' || isDWKNBYZF ) && (
                    <Popover
                      content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                      placement='bottom'
                      title={
                        '医保目录提醒符号：' +
                        (isDWKNBYZF ? '□' : m.memo)
                      }
                    >
                      <span style={{ color: 'red' }}>
                        {isDWKNBYZF ? '□' : m.memo}{' '}
                      </span>
                    </Popover>
                  )}
                  <span
                    style={{
                      color:color
                    }}
                  >
                    {m.name}
                  </span>
                  {indicator !== 'transparent' && (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'normal',
                      }}
                    >
                      {<span
                        style={{
                          color: indicator,
                        }}>
                        {m.inventoryInfo ||
                          expiredInDays <= 90 ||
                          m.unShelveInfo ||
                          m.skinTestInfo
                          ? '(' +
                          m.inventoryInfo +
                          (expiredInDays <= 90 ?
                            (expiredInDays < 0 ? (`已过期`) : (`有效期:${Math.floor(expiredInDays)}天 `)) : '') +
                          m.unShelveInfo +
                          m.skinTestInfo +
                          ')'
                          : ''}
                        <span
                           className={styles.skinTestStateTips}
                           style={{
                             display:  m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                           }}
                          onClick={() => {
                            if (m.alreadyNoticed > 0) {
                              return
                            } else {
                              if (m.skinTestState == 4) {
                                onAction && onAction('qupi', m)
                              }
                            }
                          }}
                        >
                          {m.alreadyNoticed > 0 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>已通知皮试</span>
                            </Dropdown>
                          ) : m.skinTestState == 4 ? (
                            '重新通知皮试'
                          ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>皮试</span>
                            </Dropdown>
                          ) : (
                            ''
                          )}
                        </span>
                      </span>}
                    </span>
                  )}
                </div>
                <Popover
                  overlayClassName={styles.popverContent}
                  content={getSmallTextByType(m, 0, settings)}
                  placement='bottom'
                  title={m.name}
                >
                  <div
                    className={styles.mlMesssageTips}
                    style={{
                      color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                    }}
                  >
                    {getSmallTextByType(m, 0, settings)}
                  </div>
                </Popover>
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {m.limitType === 1 && (
                  <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                    <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                  </Dropdown>
                )}
              </Col>
            </Space>
          ),
        }
      },
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'accountUnit',
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '频次',
      dataIndex: 'normalFrequency',
      align: 'center',
      width: '5.25rem',
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalFrequency',
      // ellipsis: true,
      render: (_, m) => (m.normalFrequency <= '0' ? '' : m.normalFrequency),
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '5.25rem',
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalUsemethod',
      render: (_, m) => (m.normalUsemethod <= '0' ? '' : m.normalUsemethod),
    },
    {
      title: '每次用量',
      dataIndex: 'normalDose',
      align: 'center',
      width: '3.125rem',
      editable: (record) => {
        // 根据该行状态动态判断
        return !!onSave && !readMode
      },
      nextDataIndex: 'useDays',
      onSave: onSave,
      colSpan: 2,
      render: (_, m) => (m.normalDose <= 0 ? '' : m.normalDose.toString()),
    },
    {
      dataIndex: 'doseUnit',
      align: 'center',
      width: '3.125rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'doseUnit',
    },
    {
      title: '天数',
      dataIndex: 'useDays',
      align: 'center',
      editable: !!onSave && !readMode,
      nextDataIndex: 'retailPrice',
      onSave: onSave,
      width: '4rem',
      rules: [
        {
          pattern: new RegExp(/^[0-9]\d*$/, 'g'),
          message: '请输入数字',
        },
      ],
      render: (_, m) => (m.useDays <= '0' ? '' : m.useDays),
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '7rem',
      // ellipsis: true,
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,

      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '6rem',
      // ellipsis: true,
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '4.25rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      align: 'center',
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: (_, r: any) => r?.otcRemark,
      // render: (_, m) => {
      //   let vs
      //   if (m.remark) {
      //     vs = [getOtcCategoryName(m.otc) || '暂无', m.remark]
      //   } else {
      //     vs = [getOtcCategoryName(m.otc)] || '暂无'
      //   }
      //   return vs.join('，')
      // },
    },
  ]
}

// 医嘱处方-西药方、检查、治疗、其他表头
export const MedicineMaterialColumns = (
  theme: ThemeData,
  materials: Material[],
  settings?:any,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any) => void,
  isShowVisibale?: boolean,
  openEditVisible?: (v: any) => void,
  expiredInDaysEyeFlag?: any,
  changeExpiredInDaysEyeFlag?: (v: any) => void,
  autoChangePrice?: boolean,
): EditableColumnType<Material>[] => {
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()
  const getDrugCategoryName = (drugCategory:any) => {
    if (drugCategory == '第一类精神药品') {
      return '第一类精神药品'
    }else if(drugCategory =='第二类精神药品(制剂)'){
      return '第二类精神药品(制剂)'
    }else {
      return ''
    }
  } 
  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const PSMenu = (m: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', m)
        }}
      >
        通知皮试
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '续用' })
        }}
      >
        续用
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '免皮' })
        }}
      >
        免皮
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('jgdj', m)
        }}
      >
        结果登记
      </Menu.Item>
    </Menu>
  )

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '6rem',
      render: function Element(_, m) {
        // if (m.state === -1) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '组号',
      width: '3rem',
      dataIndex: 'groupNumber',
      align: 'center',
      render: (text, m) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1,
          },
        }
        const members = groups[m.groupNumber]
        if (members && members.indexOf(m.id) === 0) {
          obj.props.rowSpan = members.length
        } else if (members) {
          obj.props.rowSpan = 0
        }
        return obj
      },
    },
    {
      title: '项目信息',
      key: 'name',
      align: 'left',
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        const isJYJE = m?.drugCategory  == '第一类精神药品' || m?.drugCategory  == '第二类精神药品(制剂)'
        const color = m?.state == 5  ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1
         // 是否单味可能不予支付
        const isDWKNBYZF  = m.memo?.indexOf('单味可能不予支付') >= 0
        if (
          m.inventoryInfo ||
          m.unShelveInfo ||
          expiredInDays <= 90 ||
          (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
        ) {
          indicator = theme.e
        } else if (
          m.skinTestTag === SkinTestStatus.NeedATest &&
          m.skinTestInfo
        ) {
          indicator = theme.w
        } else if (
          (m.skinTestTag === SkinTestStatus.Continue ||
            m.skinTestTag === SkinTestStatus.Negative) &&
          m.skinTestInfo
        ) {
          indicator = theme.s
        } else if( isJYJE){
          indicator = '#35d733'
        } else if (m?.anaesthesiaTag == 1) {
          indicator = '#FF20CE'
        }
      
        const info = m.inventoryInfo || expiredInDays <= 90 ||  m.unShelveInfo ||  m.skinTestInfo
            ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
            m.inventoryInfo +
            (expiredInDays <= 90 ?
              (expiredInDays < 0 ? (`已过期`) : (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '')) : '') +
            m.unShelveInfo +
            m.skinTestInfo +
            (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
            : ''
        return {
          props: {
            style: {
              maxWidth: 300,
              borderLeft: `4px solid ${indicator}`,
              overflow: 'hidden',
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Col>
                <div    
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                  }}               
                  className={styles.infoTips}
                >
                  {(m.memo === '□' || m.memo === '◇' || m.memo === '△' || isDWKNBYZF ) && (
                    <Popover
                      content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                      placement='bottom'
                      title={
                        '医保目录提醒符号：' +
                        (isDWKNBYZF ? '□' : m.memo)
                      }
                    >
                      <span style={{ color: 'red' }}>
                        {isDWKNBYZF ? '□' : m.memo}
                      </span>
                    </Popover>
                  )}
                  {/* isJYJE 精一精二 */}
                  {isJYJE  || m?.anaesthesiaTag == 1? (
                    <Popover
                      content={ isJYJE ? getDrugCategoryName(m?.drugCategory) : m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : ''}
                    >
                      <span style={{ color: color }}>
                        {m.name}
                      </span>
                    </Popover>
                  ) : (
                    <span style={{ color: color }}>
                      {m.name}
                    </span>
                  )}
                  {indicator !== 'transparent' && (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'normal',
                      }}
                    >
                      {<span
                        style={{
                          color: indicator,
                        }}>
                        { info }
                        <span
                           className={styles.skinTestStateTips}
                           style={{
                             display:  m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                           }}
                          onClick={() => {
                            if (m.alreadyNoticed > 0) {
                              return
                            } else {
                              if (m.skinTestState == 4) {
                                onAction && onAction('qupi', m)
                              }
                            }
                          }}
                        >
                          {m.alreadyNoticed > 0 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>已通知皮试</span>
                            </Dropdown>
                          ) : m.skinTestState == 4 ? (
                            '重新通知皮试'
                          ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>皮试</span>
                            </Dropdown>
                          ) : (
                            ''
                          )}
                        </span>
                      </span>}
                      {
                        expiredInDays <= 90 ? (
                          <span style={{ marginLeft: '10px' }}>
                            {expiredInDaysEyeFlag == '1' ? (
                              <EyeOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                                }}
                              />
                            )}
                          </span>
                        ) : ''}
                    </span>
                  )}
                </div>
                <Popover
                  overlayClassName={styles.popverContent}
                  content={getSmallTextByType(m, 0, settings)}
                  placement='bottom'
                  title={
                    <>
                      <span
                        style={{ color: color }}
                      >
                        {m.name}
                      </span>
                      {indicator !== 'transparent' && (
                        <span
                          style={{
                            fontSize: '0.875rem',
                            fontWeight: 'normal',
                          }}
                        >
                          {<span
                            style={{
                              color: indicator,
                            }}>
                             { info }
                            <span
                              className={styles.skinTestStateTips}
                              style={{
                                display:  m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                              }}
                              onClick={() => {
                                if (m.alreadyNoticed > 0) {
                                  return
                                } else {
                                  if (m.skinTestState == 4) {
                                    onAction && onAction('qupi', m)
                                  }
                                }
                              }}
                            >
                              {m.alreadyNoticed > 0 ? (
                                <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                                  <span>已通知皮试</span>
                                </Dropdown>
                              ) : m.skinTestState == 4 ? (
                                '重新通知皮试'
                              ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                                <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                                  <span>皮试</span>
                                </Dropdown>
                              ) : (
                                ''
                              )}
                            </span>
                          </span>}
                        </span>
                      )}
                    </>
                  }
                >
                  <div
                    className={styles.mlMesssageTips}
                    style={{
                      color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                    }}
                  >
                    {getSmallTextByType(m, 0, settings)}
                  </div>
                </Popover> 
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {m.limitType === 1 && (
                  <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                    <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                  </Dropdown>
                )}
              </Col>
            </Space>
          ),
        }
      },
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      editable: settings?.[Checks.MLKG] == 1 ? false : !!onSave && !readMode,
      onSave: onSave,
      inputType: 'accountUnit',
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '频次',
      dataIndex: 'normalFrequency',
      align: 'center',
      width: '5.25rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalFrequency',
      // ellipsis: true,
      render: (_, m) => (m.normalFrequency <= '0' ? '' : m.normalFrequency),
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '5.25rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalUsemethod',
      render: (_, m) => (m.normalUsemethod <= '0' ? '' : m.normalUsemethod),
    },
    {
      title: '每次用量',
      dataIndex: 'normalDose',
      align: 'center',
      width: '3.125rem',
      editable: (record) => {
        // 根据该行状态动态判断
         return record?.doseUnit == '适量' ? false : !!onSave && !readMode 
      },
      nextDataIndex: 'useDays',
      onSave: onSave,
      colSpan: 2,
      render: (_, m) => (m.normalDose <= 0 ? '' : m.normalDose.toString()),
    },
    {
      dataIndex: 'doseUnit',
      align: 'center',
      width: '3.125rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'doseUnit',
    },
    {
      title: '天数',
      dataIndex: 'useDays',
      align: 'center',
      editable: !!onSave && !readMode,
      nextDataIndex: 'retailPrice',
      onSave: onSave,
      width: '4rem',
      rules: [
        {
          pattern: new RegExp(/^[0-9]\d*$/, 'g'),
          message: '请输入数字',
        },
      ],
      render: (_, m) => (m.useDays <= '0' ? '' : m.useDays),
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '7rem',
      // ellipsis: true,
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,

      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '6rem',
      // ellipsis: true,
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '4.25rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      align: 'center',
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: function Element(_, r:any) {
        // if (m.state === -1) {
        const data = r?.otcRemark ? (r?.otcRemark.endsWith(',') || r?.otcRemark.endsWith('，') ? r?.otcRemark.slice(0, -1) : r?.otcRemark) : '-'
        return (
          <Popover content={data} overlayClassName={styles.popverContent}>
            {data}
          </Popover>
        )
      },
      // render: (_, m) => {
      //   let vs
      //   if (m.remark) {
      //     vs = [getOtcCategoryName(m.otc) || '暂无', m.remark]
      //   } else {
      //     vs = [getOtcCategoryName(m.otc)] || '暂无'
      //   }
      //   return vs.join('，')
      // },
    },
  ]
}

// 医嘱处方-西药方、检查、治疗、其他表头
export const MedicineMaterialDiscountColumns = (
  theme: ThemeData,
  materials: Material[],
  settings?:any,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any) => void,
  isShowVisibale?: boolean,
  openEditVisible?: (v: any) => void,
  expiredInDaysEyeFlag?: string,
  changeExpiredInDaysEyeFlag?: (v: string) => void,
  autoChangePrice?: boolean,
): EditableColumnType<Material>[] => {
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()

  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const PSMenu = (m: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', m)
        }}
      >
        通知皮试
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '续用' })
        }}
      >
        续用
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '免皮' })
        }}
      >
        免皮
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('jgdj', m)
        }}
      >
        结果登记
      </Menu.Item>
    </Menu>
  )

  const getDrugCategoryName = (drugCategory:any) => {
    if (drugCategory == '第一类精神药品') {
      return '第一类精神药品'
    }else if(drugCategory =='第二类精神药品(制剂)'){
      return '第二类精神药品(制剂)'
    }else {
      return ''
    }
  } 

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '5rem',
      render: function Element(_, m) {
        // if (m.state === -1) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '组号',
      width: '3rem',
      dataIndex: 'groupNumber',
      align: 'center',
      render: (text, m) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1,
          },
        }
        const members = groups[m.groupNumber]
        if (members && members.indexOf(m.id) === 0) {
          obj.props.rowSpan = members.length
        } else if (members) {
          obj.props.rowSpan = 0
        }
        return obj
      },
    },
     {
      title: '项目信息',
      key: 'name',
      align: 'left',
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        const isJYJE = m?.drugCategory  == '第一类精神药品' || m?.drugCategory  == '第二类精神药品(制剂)'
        const color = m?.state == 5  ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1
         // 是否单味可能不予支付
        const isDWKNBYZF  = m.memo?.indexOf('单味可能不予支付') >= 0
        if (
          m.inventoryInfo ||
          m.unShelveInfo ||
          expiredInDays <= 90 ||
          (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
        ) {
          indicator = theme.e
        } else if (
          m.skinTestTag === SkinTestStatus.NeedATest &&
          m.skinTestInfo
        ) {
          indicator = theme.w
        } else if (
          (m.skinTestTag === SkinTestStatus.Continue ||
            m.skinTestTag === SkinTestStatus.Negative) &&
          m.skinTestInfo
        ) {
          indicator = theme.s
        } else if( isJYJE){
          indicator = '#35d733'
        } else if (m?.anaesthesiaTag == 1) {
          indicator = '#FF20CE'
        }
        const info = m.inventoryInfo || expiredInDays <= 90 ||  m.unShelveInfo ||  m.skinTestInfo
            ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
            m.inventoryInfo +
            (expiredInDays <= 90 ?
              (expiredInDays < 0 ? (`已过期`) : (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '')) : '') +
            m.unShelveInfo +
            m.skinTestInfo +
            (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
            : ''
        return {
          props: {
            style: {
              maxWidth: 300,
              borderLeft: `4px solid ${indicator}`,
              overflow: 'hidden',
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Col>
                <div                  
                  className={styles.infoTips}
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                  }}
                >
                  {(m.memo === '□' || m.memo === '◇' || m.memo === '△' || isDWKNBYZF ) && (
                    <Popover
                      content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                      placement='bottom'
                      title={
                        '医保目录提醒符号：' +
                        (isDWKNBYZF ? '□' : m.memo)
                      }
                    >
                      <span style={{ color: 'red' }}>
                        {isDWKNBYZF ? '□' : m.memo}
                      </span>
                    </Popover>
                  )}
                  {/* isJYJE 精一精二 */}
                  {isJYJE  || m?.anaesthesiaTag == 1? (
                    <Popover
                      content={ isJYJE ? getDrugCategoryName(m?.drugCategory) : m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : ''}
                    >
                      <span style={{ color: color }}>
                         {isJYJE ? m.couponsItemName || m.name : m.name}
                      </span>
                    </Popover>
                  ) : (
                    <span style={{ color: color }}>
                     {m.couponsItemName || m.name}
                    </span>
                  )}
                  {indicator !== 'transparent' && (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'normal',
                      }}
                    >
                      {<span
                        style={{
                          color: indicator,
                        }}>
                        { info }
                        <span
                           className={styles.skinTestStateTips}
                           style={{
                             display:  m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                           }}
                          onClick={() => {
                            if (m.alreadyNoticed > 0) {
                              return
                            } else {
                              if (m.skinTestState == 4) {
                                onAction && onAction('qupi', m)
                              }
                            }
                          }}
                        >
                          {m.alreadyNoticed > 0 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>已通知皮试</span>
                            </Dropdown>
                          ) : m.skinTestState == 4 ? (
                            '重新通知皮试'
                          ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>皮试</span>
                            </Dropdown>
                          ) : (
                            ''
                          )}
                        </span>
                      </span>}
                      {
                        expiredInDays <= 90 ? (
                          <span style={{ marginLeft: '10px' }}>
                            {expiredInDaysEyeFlag == '1' ? (
                              <EyeOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                                }}
                              />
                            )}
                          </span>
                        ) : ''}
                    </span>
                  )}
                </div>
                <Popover
                  overlayClassName={styles.popverContent}
                  content={getSmallTextByType(m, 0, settings)}
                  placement='bottom'
                  title={m.couponsItemName || m.name}
                >
                  <div
                    className={styles.mlMesssageTips}
                    style={{
                      color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                    }}
                  >
                    {getSmallTextByType(m, 0, settings)}
                  </div>
                </Popover> 
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {m.limitType === 1 && (
                  <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                    <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                  </Dropdown>
                )}
              </Col>
            </Space>
          ),
        }
      },
    },
    {
      title: '折后单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '5rem',
      ellipsis: false,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '折前单价',
      dataIndex: 'retailBeforePrice',
      align: 'right',
      width: '5rem',
      ellipsis: false,
    },
    {
      title: '折扣%',
      dataIndex: 'discount',
      align: 'center',
      width: '4rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'drugCount',
      onSave: (record:any, values) => {
        if (values.discount) 
          values.retailPrice = Number(record.retailBeforePrice) * (Number(values.discount) /100) 
        onSave && onSave(record, values)
      } ,
      rules: [
        {
          pattern: /[1-9]\d*$/,
          message: '请输入大于0的整数',
        },
        { required: true, message: '请输入必填项' },
      ],
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '6rem',
      // ellipsis: true,
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      editable: settings?.[Checks.MLKG] == 1 ? false : !!onSave && !readMode,
      onSave: onSave,
      inputType: 'accountUnit',
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '频次',
      dataIndex: 'normalFrequency',
      align: 'center',
      width: '5.25rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalFrequency',
      // ellipsis: true,
      render: (_, m) => (m.normalFrequency <= '0' ? '' : m.normalFrequency),
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '5.25rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalUsemethod',
      render: (_, m) => (m.normalUsemethod <= '0' ? '' : m.normalUsemethod),
    },
    {
      title: '每次用量',
      dataIndex: 'normalDose',
      align: 'center',
      width: '3.125rem',
      editable: (record) => {
        // 根据该行状态动态判断
        return record?.doseUnit == '适量' ? false : !!onSave && !readMode 
      },
      nextDataIndex: 'useDays',
      onSave: onSave,
      colSpan: 2,
      render: (_, m) => (m.normalDose <= 0 ? '' : m.normalDose.toString()),
    },
    {
      dataIndex: 'doseUnit',
      align: 'center',
      width: '3.125rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'doseUnit',
    },
    {
      title: '天数',
      dataIndex: 'useDays',
      align: 'center',
      editable: !!onSave && !readMode,
      nextDataIndex: 'retailPrice',
      onSave: onSave,
      width: '4rem',
      rules: [
        {
          pattern: new RegExp(/^[0-9]\d*$/, 'g'),
          message: '请输入数字',
        },
      ],
      render: (_, m) => (m.useDays <= '0' ? '' : m.useDays),
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '3rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      align: 'center',
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: function Element(_, r:any) {
        // if (m.state === -1) {
        const data = r?.otcRemark ?  (r?.otcRemark.endsWith(',') || r?.otcRemark.endsWith('，') ? r?.otcRemark.slice(0, -1) : r?.otcRemark ) : '-'
        return (
          <Popover content={data} overlayClassName={styles.popverContent}>
            {data}
          </Popover>
        )
      },
      // render: (_, m) => {
      //   let vs
      //   if (m.remark) {
      //     vs = [getOtcCategoryName(m.otc) || '暂无', m.remark]
      //   } else {
      //     vs = [getOtcCategoryName(m.otc)] || '暂无'
      //   }
      //   return vs.join('，')
      // },
    },
  ]
}

// 中医治疗方
export const TcmTreatColumn = (
  theme: ThemeData,
  materials: Material[],
  settings: any,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any) => void,
  isShowVisibale?: boolean,
  openEditVisible?: (v: any) => void,
  expiredInDaysEyeFlag?: string,
  changeExpiredInDaysEyeFlag?: (v: string) => void,
  chooseTreatmentParts?: (v: any) => void,
  acupointList?: any,
): EditableColumnType<Material>[] => {

  const getDrugCategoryName = (drugCategory: any) => {
    if (drugCategory == '第一类精神药品') {
      return '第一类精神药品'
    } else if (drugCategory == '第二类精神药品(制剂)') {
      return '第二类精神药品(制剂)'
    } else {
      return ''
    }
  }

  // 根据 id 获取名称
  const getNameById = (id: string): string => {
    // 搜索穴位列表
    for (const firstItem of acupointList?.acupointList || []) {
      for (const secondItem of firstItem?.child || []) {
        for (const thirdItem of secondItem?.child || []) {
          if (thirdItem.id == id) {
            return thirdItem.acuName
          }
        }
      }
    }
    // 搜索身体部位列表
    for (const secondItem of acupointList?.bodyList?.child || []) {
      for (const thirdItem of secondItem?.child || []) {
        if (thirdItem.id == id) {
          return thirdItem.acuName
        }
        for (const fourthItem of thirdItem?.child || []) {
          if (fourthItem.id == id) {
            return fourthItem.acuName
          }
        }
      }
    }
    return id
  }
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()

  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const PSMenu = (m: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', m)
        }}
      >
        通知皮试
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '续用' })
        }}
      >
        续用
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '免皮' })
        }}
      >
        免皮
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('jgdj', m)
        }}
      >
        结果登记
      </Menu.Item>
    </Menu>
  )

 return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '6rem',
      render: function Element(_, m) {
        // if (m.state === -1) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '组号',
      width: '3rem',
      dataIndex: 'groupNumber',
      align: 'center',
      render: (text, m) => {
        const obj = {
          children: text,
          props: {
            rowSpan: 1,
          },
        }
        const members = groups[m.groupNumber]
        if (members && members.indexOf(m.id) === 0) {
          obj.props.rowSpan = members.length
        } else if (members) {
          obj.props.rowSpan = 0
        }
        return obj
      },
   },
   {
     title: '项目信息',
     key: 'name',
     align: 'left',
     render: function MaterialName(_, m: Material) {
       let indicator = 'transparent'
       const expiredInDays = m.deadline
         ? moment.duration(moment(m.deadline).diff(moment())).asDays()
         : 9999
       const isJYJE = m?.drugCategory == '第一类精神药品' || m?.drugCategory == '第二类精神药品(制剂)'
       const color = m?.state == 5 ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1
       // 是否单味可能不予支付
       const isDWKNBYZF = m.memo?.indexOf('单味可能不予支付') >= 0
       if (
         m.inventoryInfo ||
         m.unShelveInfo ||
         expiredInDays <= 90 ||
         (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
       ) {
         indicator = theme.e
       } else if (
         m.skinTestTag === SkinTestStatus.NeedATest &&
         m.skinTestInfo
       ) {
         indicator = theme.w
       } else if (
         (m.skinTestTag === SkinTestStatus.Continue ||
           m.skinTestTag === SkinTestStatus.Negative) &&
         m.skinTestInfo
       ) {
         indicator = theme.s
       } else if (isJYJE) {
         indicator = '#35d733'
       } else if (m?.anaesthesiaTag == 1) {
         indicator = '#FF20CE'
       }
       const info = m.inventoryInfo || expiredInDays <= 90 || m.unShelveInfo || m.skinTestInfo
         ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
         m.inventoryInfo +
         (expiredInDays <= 90 ?
           (expiredInDays < 0 ? (`已过期`) : (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '')) : '') +
         m.unShelveInfo +
         m.skinTestInfo +
         (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
         : ''
       return {
         props: {
           style: {
             maxWidth: 300,
             borderLeft: `4px solid ${indicator}`,
             overflow: 'hidden',
           },
         },
         children: (
           <Space
             style={{ display: 'flex', justifyContent: 'space-between' }}
             onDoubleClick={() => {
               openEditVisible && openEditVisible(m)
             }}
           >
             <Col>
               <div
                 className={styles.infoTips}
                 style={{
                   color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                 }}
               >
                 {(m.memo === '□' || m.memo === '◇' || m.memo === '△' || isDWKNBYZF) && (
                   <Popover
                     content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                     placement='bottom'
                     title={
                       '医保目录提醒符号：' +
                       (isDWKNBYZF ? '□' : m.memo)
                     }
                   >
                     <span style={{ color: 'red' }}>
                       {isDWKNBYZF ? '□' : m.memo}
                     </span>
                   </Popover>
                 )}
                 {/* isJYJE 精一精二 */}
                 {isJYJE || m?.anaesthesiaTag == 1 ? (
                   <Popover
                     content={isJYJE ? getDrugCategoryName(m?.drugCategory) : m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : ''}
                   >
                     <span style={{ color: color }}>
                       {m.name}
                     </span>
                   </Popover>
                 ) : (
                   <span style={{ color: color }}>
                     {m.name}
                   </span>
                 )}
                 {indicator !== 'transparent' && (
                   <span
                     style={{
                       fontSize: '0.875rem',
                       fontWeight: 'normal',
                     }}
                   >
                     {<span
                       style={{
                         color: indicator,
                       }}>
                       {info}
                       <span
                         className={styles.skinTestStateTips}
                         style={{
                           display: m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                         }}
                         onClick={() => {
                           if (m.alreadyNoticed > 0) {
                             return
                           } else {
                             if (m.skinTestState == 4) {
                               onAction && onAction('qupi', m)
                             }
                           }
                         }}
                       >
                         {m.alreadyNoticed > 0 ? (
                           <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                             <span>已通知皮试</span>
                           </Dropdown>
                         ) : m.skinTestState == 4 ? (
                           '重新通知皮试'
                         ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                           <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                             <span>皮试</span>
                           </Dropdown>
                         ) : (
                           ''
                         )}
                       </span>
                     </span>}
                     {
                       expiredInDays <= 90 ? (
                         <span style={{ marginLeft: '10px' }}>
                           {expiredInDaysEyeFlag == '1' ? (
                             <EyeOutlined
                               style={{ fontSize: '13px' }}
                               onClick={() => {
                                 changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                               }}
                             />
                           ) : (
                             <EyeInvisibleOutlined
                               style={{ fontSize: '13px' }}
                               onClick={() => {
                                 changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                               }}
                             />
                           )}
                         </span>
                       ) : ''}
                   </span>
                 )}
               </div>
               <Popover
                 overlayClassName={styles.popverContent}
                 content={getSmallTextByType(m, 0, settings)}
                 placement='bottom'
                 title={
                   <>
                     <span
                       style={{ color: color }}
                     >
                       {m.name}
                     </span>
                     {indicator !== 'transparent' && (
                       <span
                         style={{
                           fontSize: '0.875rem',
                           fontWeight: 'normal',
                         }}
                       >
                         {<span
                           style={{
                             color: indicator,
                           }}>
                           {info}
                           <span
                             className={styles.skinTestStateTips}
                             style={{
                               display: m.skinTestState == 4 ? 'inline-block' : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? 'inline-block' : 'none',
                             }}
                             onClick={() => {
                               if (m.alreadyNoticed > 0) {
                                 return
                               } else {
                                 if (m.skinTestState == 4) {
                                   onAction && onAction('qupi', m)
                                 }
                               }
                             }}
                           >
                             {m.alreadyNoticed > 0 ? (
                               <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                                 <span>已通知皮试</span>
                               </Dropdown>
                             ) : m.skinTestState == 4 ? (
                               '重新通知皮试'
                             ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                               <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                                 <span>皮试</span>
                               </Dropdown>
                             ) : (
                               ''
                             )}
                           </span>
                         </span>}
                       </span>
                     )}
                   </>
                 }
               >
                 <div
                   className={styles.mlMesssageTips}
                   style={{
                     color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                   }}
                 >
                   {getSmallTextByType(m, 0, settings)}
                 </div>
               </Popover>
             </Col>
             <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
               {m.limitType === 1 && (
                 <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                   <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                 </Dropdown>
               )}
             </Col>
           </Space>
         ),
       }
     },
   },
    {
      title: '部位/穴位',
      dataIndex: 'treatmentParts',
      align: 'center',
      width: '10rem',
      nextDataIndex: 'drugCount',
      render: function Element(_, m: any) {
        const textArr:any = [];
        try {
          const safeArray = JSON.parse(m?.treatmentParts); // 解析字符串
          if(Array.isArray(safeArray)){
            safeArray.map((v) =>{
              textArr.push(getNameById(v))
            })
          }
        } catch (e) {
          console.log("穴位解析异常：",e)
        }



        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Popover content={textArr.join(',')}>
              <div style={{ width: '80%', textAlign:'left', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {textArr.join(',')}
              </div>
            </Popover>

            {(!!onSave && !readMode) && (
              <div
                style={{
                  width: '26px',
                  height: '26px',
                  borderRadius: '50%',
                  backgroundColor: '#eee',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  chooseTreatmentParts && chooseTreatmentParts( m)
                }}
              >
                <img src={bwwxwImg} style={{ width: '22px', height: '22px' }}></img>
              </div>
              )

            }

          </div>
        )
      },
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'retailPrice',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'accountUnit',
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
   
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '7rem',
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '6rem',
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      align: 'center',
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: function Element(_, r:any) {
        // if (m.state === -1) {
        const data = r?.otcRemark ? (r?.otcRemark.endsWith(',') || r?.otcRemark.endsWith('，') ? r?.otcRemark.slice(0, -1) : r?.otcRemark) : '-'
        return (
          <Popover content={data} overlayClassName={styles.popverContent}>
            {data}
          </Popover>
        )
      },
    },
  ]
}

// 新老目录展示方式
//获取药品/诊疗项目名字下方的小字文本，
//type 0：西药或其他，1：中草药（或配方颗粒），2：处置项目
const getSmallTextByType = (m: any, type: number,settings?:any) => {
  const materialsCategory = m.materialsCategory
  const batchNo = (location.pathname == '/payment/cart' && m?.batchNo) ? ('/' + '批号:' + m?.batchNo) : '' //批号
  const limitPrice = m.limitPrice > 0 && m.limitPrice < 99999 ? '/' + '医保限价：' + `${m.limitPrice}`: '' //医保限价
  const drugType = m.drugType  //药品类型
  const hilistCode = m.hilistCode ? '/' + m.hilistCode : '' //医保编码
  const proviceHilistCode = m.proviceHilistCode ? '/' + m.proviceHilistCode : '' //医保省码
  const spec = m.spec ? m.spec : '-' //规格
  const packSpec = m.packSpec ? m.packSpec : '-' //包装规格
  const accountUnit = m.accountUnit ? m.accountUnit : '-' //包装单位（账簿单位）
  const doseCategory = m.doseCategory ? m.doseCategory : '-' //剂量
  const billingCategory = m.billingCategory ? m.billingCategory : '-' 
  const tenantSupplierName = m.tenantSupplierName ? m.tenantSupplierName : '-' //生产厂家
  const model = m.model ? m.model + '/' : '' //型号
          
  // 药品
                                   // 规格 + 包装规格 + 包装单位（账簿单位） + 剂量 + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
  const oldMaterialsCategoryZero = `${spec}/${packSpec}/${accountUnit}/${doseCategory}/${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`
  const newMaterialsCategoryZero = `${packSpec}/${doseCategory}/${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`

  // 材料器械
                                   // 规格 + 包装规格 + 包装单位（账簿单位） + 型号 + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
  const oldMaterialsCategoryOne = `${spec}/${packSpec}/${accountUnit}/${model}${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`
  const newMaterialsCategoryOne = `${packSpec}/${model}${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`

  // 其他
                                   // 规格 + 包装规格 + 包装单位（账簿单位） + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
  const oldMaterialsCategoryTwo = `${spec}/${packSpec}/${accountUnit}/${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`
  const newMaterialsCategoryTwo = `${packSpec}/${tenantSupplierName}${hilistCode}${proviceHilistCode}${batchNo}${limitPrice}`

  // type == 0 西药或其他  type == 2：处置项目
  if (type == 0 || type == 2) {
    // 诊疗
    if (drugType == 1) {
      // 医保编码 + 医保省码 + 限价
      return `诊疗${hilistCode}${proviceHilistCode}${limitPrice}`
    } else {
      if (settings?.[Checks.MLKG] == 1) {
        if (materialsCategory == 0) {
          //  包装规格 + 剂量 + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
          return newMaterialsCategoryZero
        } else if (materialsCategory == 1 || materialsCategory == 2) {
          //  包装规格 + 型号 + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
          return newMaterialsCategoryOne
        } else {
          //  包装规格 + 生产厂家 + 医保编码 + 医保省码 + 批号 + 限价
          return newMaterialsCategoryTwo
        }
      } else {
        if (materialsCategory == 0) {
          return oldMaterialsCategoryZero
        } else if (materialsCategory == 1 || materialsCategory == 2) {
          return oldMaterialsCategoryOne
        } else {
          return oldMaterialsCategoryTwo
        }
      }
    }
  } else if (type == 1) {
    // 1：中草药（或配方颗粒）
    if (settings?.[Checks.MLKG] == 1) {
      //billingCategory == 97 代煎费
      if (billingCategory !== '97') {
        if (materialsCategory == 0) {
          return newMaterialsCategoryZero
        } else if (materialsCategory == 1 || materialsCategory == 2) {
          return newMaterialsCategoryOne
        } else {
          return newMaterialsCategoryTwo
        }
      } else {
        return `${packSpec}/${hilistCode}/${proviceHilistCode}${batchNo}/${limitPrice}`
      }
    } else {
      if (billingCategory !== '97') {
        if (materialsCategory == 0) {
          return oldMaterialsCategoryZero
        } else if (materialsCategory == 1 || materialsCategory == 2) {
          return oldMaterialsCategoryOne
        } else {
          return oldMaterialsCategoryTwo
        }
      } else {
        return `${spec}/${packSpec}/${accountUnit}/${hilistCode}/${proviceHilistCode}${batchNo}/${limitPrice}`
      }
    }
  }
}

// 医嘱处方-中药方表
export const TcmColumns = (
  settings: any,
  theme: ThemeData,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  recipeCategory?: any,
  openEditVisible?: (v: any) => void,
  readMode?: boolean,
  insuranceArray?: any,
  expiredInDaysEyeFlag?: any,
  changeExpiredInDaysEyeFlag?: (v: any) => void
): EditableColumnType<Material>[] => {
  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>
          {v.quarterType == 1 && insuranceArray?.[0]?.chinese25pcAlert == 1
            ? '中草药单价不能超过成本25%,'
            : ''}{' '}
          {v.limitType == 1 ? `超出医保最高价格：${v?.limitPrice}元` : ''}
        </Menu.Item>
        {/* <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item> */}
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '5rem',
      render: function Element(_, m) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              className={styles.sfType}
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => (index + 1).toString(),
    },
    {
      title: '药品信息',
      key: 'name',
      align: 'left',
      // width: '20rem',
      ellipsis: true,
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        if (m.inventoryInfo || m.unShelveInfo || expiredInDays <= 90) {
          indicator = theme.e
        } else if (m?.anaesthesiaTag == 1) {
          indicator = '#FF20CE'
        }
        const color = m?.state == 5 ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1
        // 是否单味可能不予支付
        const isDWKNBYZF = m.memo?.indexOf('单味可能不予支付') >= 0
        return {
          props: {
            style: {
              borderLeft: `4px solid ${indicator}`,
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Row align='bottom'>
                <div
                  className={styles.infoTipsZY}
                  style={{
                    color: m.quarterType == 1 && insuranceArray?.[0]?.chinese25pcAlert == 1 ? '#ff5d5d' : theme.tc1,
                  }}
                >
                  {isDWKNBYZF && (
                    <Popover
                      content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                      placement='bottom'
                      title={
                        '医保目录提醒符号：' +
                        (isDWKNBYZF ? '□' : m.memo)
                      }
                    >
                      <span style={{ color: 'red' }}>
                        {isDWKNBYZF ? '□' : m.memo}{' '}
                      </span>
                    </Popover>
                  )}
                  {m?.anaesthesiaTag == 1 ? (
                    <Popover content={'属于毒麻类药物'}>
                      <span style={{ color: color }}>
                        {m.name}
                      </span>
                    </Popover>
                  ) : (
                    <span style={{ color: color }}>
                      {m.name}
                    </span>
                  )}
                  {indicator !== 'transparent' && (
                    <span>
                      <span style={{ color: indicator }}>
                        {m.inventoryInfo || expiredInDays <= 90 || m.unShelveInfo
                          ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
                          m.inventoryInfo +
                          (expiredInDays <= 90
                            ? (expiredInDays <= 90 ?
                              expiredInDays < 0 ? (`已过期`) : (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '') : '')
                            : '') +
                          m.unShelveInfo +
                          (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
                          : ''}
                      </span>
                      {
                        expiredInDays <= 90 ? (
                          <span style={{ marginLeft: '10px' }}>
                            {expiredInDaysEyeFlag == '1' ? (
                              <EyeOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                                }}
                              />
                            )}
                          </span>
                        ) : ''}
                    </span>
                  )}
                </div>
                <Popover
                  overlayClassName={styles.popverContent}
                  content={getSmallTextByType(m, 1, settings)}
                  placement='bottom'
                  title={m.name}
                >
                  <div
                    style={{
                      color:
                        m.quarterType == 1 &&
                          insuranceArray?.[0]?.chinese25pcAlert == 1
                          ? '#ff5d5d'
                          : theme.tc3,
                      fontSize: '0.75rem',
                      lineHeight: '0.75rem',
                      marginLeft: 4,
                    }}
                  >
                    {getSmallTextByType(m, 1, settings)}
                  </div>
                </Popover>
              </Row>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {((m.quarterType == 1 &&
                  insuranceArray?.[0]?.chinese25pcAlert == 1) ||
                  m.limitType == 1) && (
                    <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                      <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                    </Dropdown>
                  )}
              </Col>
            </Space>
          ),
        }
      },
    },
    {
      title: '每帖数量',
      dataIndex: 'countPerTip',
      nextDataIndex: 'retailPrice',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
    },
    {
      title: '总数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '6rem',
      // ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalUsemethod',
      recipeCategory: recipeCategory,
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '5rem',
      ellipsis: true,
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,
      render: (_, r) => r.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '5rem',
      ellipsis: true,
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '5rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
  ]
}

// 快速开单中药方展示折扣表
export const TcmDiscountColumns = (
  settings: any,
  theme: ThemeData,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  recipeCategory?: any,
  openEditVisible?: (v: any) => void,
  readMode?: boolean,
  insuranceArray?: any,
  expiredInDaysEyeFlag?: any,
  changeExpiredInDaysEyeFlag?: (v: any) => void
): EditableColumnType<Material>[] => {
  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>
          {v.quarterType == 1 && insuranceArray?.[0]?.chinese25pcAlert == 1
            ? '中草药单价不能超过成本25%,'
            : ''}
          {v.limitType == 1 ? `超出医保最高价格：${v?.limitPrice}元` : ''}
        </Menu.Item>
        {/* <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item> */}
      </Menu>
    )
  }

  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '4.5rem',
      render: function Element(_, m) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => (index + 1).toString(),
    },
    {
      title: '药品信息',
      key: 'name',
      align: 'left',
      width: '16rem',
      ellipsis: true,
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        if (m.inventoryInfo || m.unShelveInfo || expiredInDays <= 90) {
          indicator = theme.e
        } else if (m?.anaesthesiaTag == 1) {
          indicator = '#FF20CE'
        }
        const color = m?.state == 5 ? '#ccc' : m?.state == 3 ? theme.s : theme.tc1
        // 是否单味可能不予支付
        const isDWKNBYZF = m.memo?.indexOf('单味可能不予支付') >= 0
        return {
          props: {
            style: {
              borderLeft: `4px solid ${indicator}`,
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Row align='bottom'>
                <div
                  className={styles.infoTips}
                  style={{
                    color: m.quarterType == 1 && insuranceArray?.[0]?.chinese25pcAlert == 1 ? '#ff5d5d': theme.tc1,
                  }}
                >
                  {isDWKNBYZF && (
                    <Popover
                      content={'一般用于标识单品不予支付、相同适应症归类等含义'}
                      placement='bottom'
                      title={
                        '医保目录提醒符号：' +
                        (isDWKNBYZF ? '□' : m.memo)
                      }
                    >
                      <span style={{ color: 'red' }}>
                        {isDWKNBYZF ? '□' : m.memo}{' '}
                      </span>
                    </Popover>
                  )}
                  {m?.anaesthesiaTag == 1 ? (
                    <Popover content={'属于毒麻类药物'}>
                      <span style={{ color: color }}>
                        {m.name}
                      </span>
                    </Popover>
                  ) : (
                    <span style={{ color: color }}>
                      {m.name}
                    </span>
                  )}
                  {indicator !== 'transparent' && (
                    <span>
                      <span style={{ color: indicator }}>
                        {m.inventoryInfo || expiredInDays <= 90 || m.unShelveInfo
                          ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
                          m.inventoryInfo +
                          (expiredInDays <= 90
                            ? (expiredInDays <= 90 ?
                              expiredInDays < 0 ? (`已过期`) :
                                (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '') : '')
                            : '') +
                          m.unShelveInfo +
                          (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
                          : ''}
                      </span>
                      {
                        expiredInDays <= 90 ? (
                          <span style={{ marginLeft: '10px' }}>
                            {expiredInDaysEyeFlag == '1' ? (
                              <EyeOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                                }}
                              />
                            )}
                          </span>
                        ) : ''}
                    </span>
                  )}
                </div>
                <Popover
                  overlayClassName={styles.popverContent}
                  content={getSmallTextByType(m, 1 , settings)}
                  placement='bottom'
                  title={m.name}
                >
                  <div
                    style={{
                      color:
                        m.quarterType == 1 &&
                        insuranceArray?.[0]?.chinese25pcAlert == 1
                          ? '#ff5d5d'
                          : theme.tc3,
                      fontSize: '0.75rem',
                      lineHeight: '0.75rem',
                      marginLeft: 4,
                    }}
                  >
                    {getSmallTextByType(m, 1 , settings)}
                  </div>
                </Popover>
              </Row>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {((m.quarterType == 1 &&
                  insuranceArray?.[0]?.chinese25pcAlert == 1) ||
                  m.limitType == 1) && (
                    <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                      <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                    </Dropdown>
                  )}
              </Col>
            </Space>
          ),
        }
      },
    },
    {
      title: '折后单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '5rem',
      ellipsis: true,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '折前单价',
      dataIndex: 'retailBeforePrice',
      align: 'right',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '折扣%',
      dataIndex: 'discount',
      align: 'center',
      width: '5rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'countPerTip',
      onSave: (record:any, values) => {
        if (values.discount) 
          // values.discount = Number(values.discount) / 100
          values.retailPrice = Number(record.retailBeforePrice) * (Number(values.discount) / 100) 
        onSave && onSave(record, values)
      } ,
      rules: [
        {
          pattern: /[1-9]\d*$/,
          message: '请输入大于0的整数',
        },
        { required: true, message: '请输入必填项' },
      ],
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '4rem',
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '每帖数量',
      dataIndex: 'countPerTip',
      nextDataIndex: 'retailPrice',
      align: 'center',
      width: '5rem',
      editable: !!onSave && !readMode,
      onSave: onSave,
    },
    {
      title: '总数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '4rem',
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '6rem',
      // ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'normalUsemethod',
      recipeCategory: recipeCategory,
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '5rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
  ]
}

// 医嘱处方-处置项目表
export const DisposeColumns = (
  theme: ThemeData,
  materials: Material[],
  settings: any,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any, tooth?: string, toothType?: number) => void,
  openEditVisible?: (v: any) => void,
  isEdit?: boolean,
  expiredInDaysEyeFlag?: any,
  changeExpiredInDaysEyeFlag?: (v: any) => void,
  discountFlag?: boolean
): EditableColumnType<Material>[] => {
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()

  const menu = (v: any) => (
    <Menu
      onClick={(item) => {
        onItemChange && onItemChange(Number(item.key), v)
      }}
    >
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }
  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const PSMenu = (m: any) => (
    <Menu>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', m)
        }}
      >
        通知皮试
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '续用' })
        }}
      >
        续用
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('qupi', { ...m, skinTestInfo: '免皮' })
        }}
      >
        免皮
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          onAction && onAction('jgdj', m)
        }}
      >
        结果登记
      </Menu.Item>
    </Menu>
  )
  const columns: EditableColumnType<any>[] =  [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '5.25rem',
      render: function Element(_, m) {
        // if (m.state === -1) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => (index + 1).toString(),
    },
    {
      title: '牙位',
      key: 'toothStruct',
      width: '11.5rem',
      align: 'center',
      render: function MaterialName(_, m: Material) {
        return (
          <ToothComponents
            czxmFlag = {true}
            data={m.toothStruct}
            isEdit={isEdit}
            onChange={(v: any, type = 0) => {
              const tooth = v.map((v: any) => (v ? v : '--'))
              onAction && onAction('toothEdit', m, tooth.join('@'), type)
            }}
          />
          // 3La-B,5,6@3D-P,5O@--@2L
        )
      },
    },
    {
      title: '处置信息',
      key: 'name',
      align: 'left',
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        if (
          m.inventoryInfo ||
          m.unShelveInfo ||
          expiredInDays <= 90 ||
          (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
        ) {
          indicator = theme.e
        } else if (
          m.skinTestTag === SkinTestStatus.NeedATest &&
          m.skinTestInfo
        ) {
          indicator = theme.w
        } else if (
          (m.skinTestTag === SkinTestStatus.Continue ||
            m.skinTestTag === SkinTestStatus.Negative) &&
          m.skinTestInfo
        ) {
          indicator = theme.s
        }
        return {
          props: {
            style: {
              maxWidth: 200,
              borderLeft: `4px solid ${indicator}`,
              overflow: 'hidden',
            },
          },
          children: (
            <Space
              style={{ display: 'flex', justifyContent: 'space-between' }}
              onDoubleClick={() => {
                openEditVisible && openEditVisible(m)
              }}
            >
              <Col>
                <div
                  className={styles.infoTips}
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                  }}
                >
                  {m.name}
                  {indicator !== 'transparent' && (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'normal',
                      }}
                    >
                      {<span
                        style={{
                          color: indicator,
                        }}>
                        {m.inventoryInfo ||
                          expiredInDays <= 90 ||
                          m.unShelveInfo ||
                          m.skinTestInfo
                          ? (expiredInDaysEyeFlag == '1' ? '(' : expiredInDaysEyeFlag == '0' ? '' : '(') +
                          m.inventoryInfo +
                          (expiredInDays <= 90 ?
                            expiredInDays < 0 ? (`已过期`) :
                              (expiredInDaysEyeFlag == '1' ? `有效期:${Math.floor(expiredInDays)}天 ` : '') : '') +
                          m.unShelveInfo +
                          m.skinTestInfo +
                          (expiredInDaysEyeFlag == '1' ? ')' : expiredInDaysEyeFlag == '0' ? '' : ')')
                          : ''}
                        <span
                          style={{
                            display:
                              m.skinTestState == 4
                                ? 'inline-block'
                                : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5
                                  ? 'inline-block' : 'none',
                            color: '#000',
                            marginLeft: '10px',
                            fontSize: '13px',
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            padding: '5px',
                            cursor: 'pointer'
                          }}
                          onClick={() => {
                            if (m.alreadyNoticed > 0) {
                              return
                            } else {
                              if (m.skinTestState == 4) {
                                onAction && onAction('qupi', m)
                              }
                            }
                          }}
                        >
                          {m.alreadyNoticed > 0 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>已通知皮试</span>
                            </Dropdown>
                          ) : m.skinTestState == 4 ? (
                            '重新通知皮试'
                          ) : m.skinTestState == 1 || m.skinTestState == 2 || m.skinTestState == 5 ? (
                            <Dropdown overlay={PSMenu(m)} trigger={['click']}>
                              <span>皮试</span>
                            </Dropdown>
                          ) : (
                            ''
                          )}
                        </span>
                      </span>}
                      {
                        expiredInDays <= 90 ? (
                          <span style={{ marginLeft: '10px' }}>
                            {expiredInDaysEyeFlag == '1' ? (
                              <EyeOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('0')
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                style={{ fontSize: '13px' }}
                                onClick={() => {
                                  changeExpiredInDaysEyeFlag && changeExpiredInDaysEyeFlag('1')
                                }}
                              />
                            )}
                          </span>
                        ) : ''}
                    </span>
                  )}
                </div>

                <Popover
                  content={getSmallTextByType(m, 2, settings)}
                  placement='bottom'
                  title={m.name}
                >
                  <div
                    style={{
                      color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                      fontSize: '0.75rem',
                      lineHeight: '0.75rem',
                      marginBottom: 10,
                      marginTop: 4,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {getSmallTextByType(m, 2, settings)}
                  </div>
                </Popover>
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {m.limitType === 1 && (
                  <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                    <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                  </Dropdown>
                )}
              </Col>
              {/* </Popover> */}
            </Space>
          ),
        }
      },
    },
    {
      title: '折后单价',
      dataIndex: 'retailPrice',
      key: 'zhdj',
      align: 'right',
      width: '5rem',
      ellipsis: false,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '折前单价',
      dataIndex: 'retailBeforePrice',
      key: 'zqdj',
      align: 'right',
      width: '5rem',
      ellipsis: false,
    },
    {
      title: '折扣%',
      key: 'zk',
      dataIndex: 'discount',
      align: 'center',
      width: '4rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'drugCount',
      onSave: (record:any, values) => {
        if (values.discount) 
          // values.discount = Number(values.discount) / 100
          values.retailPrice = Number(record.retailBeforePrice) * (Number(values.discount) / 100) 
        onSave && onSave(record, values)
      } ,
      rules: [
        {
          pattern: /[1-9]\d*$/,
          message: '请输入大于0的整数',
        },
        { required: true, message: '请输入必填项' },
      ],
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      editable: !!onSave && !readMode,
      onSave: onSave,
      inputType: 'accountUnit',
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '3.75rem',
      render: (_, m) => (m.normalUsemethod <= '0' ? '' : m.normalUsemethod),
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '4.5rem',
      ellipsis: true,
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      width: '4rem',
      render: function Element(_, r) {
        // if (m.state === -1) {
        return (
          <div
            style={{
              textAlign: 'right',
              overflow: 'hidden',
            }}
          >
            {r.drugAmount?.toFixed(2)}
          </div>
        )
      },
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '4.25rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      align: 'center',
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: (_, m) => {
        let vs
        if (m.remark) {
          if (getOtcCategoryName(m.otc)) {
            vs = [getOtcCategoryName(m.otc), m.remark]
          } else {
            vs = [m.remark]
          }
        } else {
          vs = [getOtcCategoryName(m.otc)]
        }
        return vs.join('，')
      },
    },
  ]

  return discountFlag ? columns : columns?.filter((c) => c.key !== 'zhdj' && c.key !== 'zqdj' && c.key !== 'zk')
}

// 口腔版处置记录表
export const toothDisposeColumns = (
  theme: ThemeData,
  materials: Material[],
  settings: any
): EditableColumnType<Material>[] => {
  const groups = _.chain(materials)
    .groupBy((m) => m.groupNumber)
    .mapValues((ms) => ms.map((m) => m.id))
    .value()

  const menu = (v: any) => (
    <Menu>
      <Menu.Item style={{ fontWeight: 'bold', color: '#af623c' }} key='0'>
        自费 
      </Menu.Item>
      {v.hilistCode && v.insuranceCode !== 'ZIFEI' && (
        <>
          <Menu.Item key='1' style={{ fontWeight: 'bold', color: '#088f52' }}>
            医保
          </Menu.Item>
          <Menu.Item key='3' style={{ fontWeight: 'bold', color: '#027aff' }}>
            历年
          </Menu.Item>
        </>
      )}

      {/* <Menu.Item key='2'>免费</Menu.Item> */}
    </Menu>
  )
  const medicalMenu = (v: any) => {
    return (
      <Menu>
        <Menu.Item key='0'>超出医保最高价格：{v?.limitPrice}元</Menu.Item>
      </Menu>
    )
  }

  // 新老目录展示方式 (老目录没有型号)
  const getProcuctInfo = (item: any) => {
    const drugType = item.drugType
    const hilistCode = item.hilistCode ? item.hilistCode : '-'
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const spec = item.spec ? item.spec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? item.model + '/'  : ''
    const accountUnit = item.accountUnit ? item.accountUnit : '-'

    if (drugType === 1) {
      return `诊疗/${hilistCode}`
    } else {
      if (settings?.[Checks.MLKG] == 1) {
        if (materialsCategory == '0') {
          // 包装规格 + 剂型  + 生产厂家+ 医保编码
          return packSpec + '/' + doseCategory + '/' + tenantSupplierName + '/' + hilistCode
        } else if (materialsCategory == '1' || materialsCategory == '2') {
          // 包装规格 + 型号 + 生产厂家  + 医保编码
          return packSpec + '/' + model + tenantSupplierName + '/' + hilistCode
        } else {
          // 包装规格 + 生产厂家 + 医保编码
          return packSpec + '/' + tenantSupplierName + '/' + hilistCode
        }
      } else {
        if (materialsCategory == '0') {
          // 规格 + 包装规格 + 包装单位(账簿单位) + 剂型  + 生产厂家  + 医保编码
          return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName + '/' + hilistCode
        } else if (materialsCategory == '1' || materialsCategory == '2') {
          // 规格 + 包装规格 + 包装单位(账簿单位) + 型号  + 生产厂家 + 医保编码
          return spec + '/' + packSpec + '/' + accountUnit + '/' + model + tenantSupplierName + '/' + hilistCode
        } else {
          // 规格 + 包装规格 + 包装单位(账簿单位) + 生产厂家  + 医保编码
          return spec + '/' + packSpec + '/' + accountUnit + '/' + tenantSupplierName + '/' + hilistCode
        }
      }
    }
  }
  
  const getPayTypeName = (payType: number) => {
    switch (payType) {
      case 0:
        return '自费'
      case 1:
        return '医保'
      case 2:
        return '免费'
      case 3:
        return '历年'
      default:
        return ''
    }
  }

  const getAlreadyNoticed = (alreadyNoticed: any) => {
    if (alreadyNoticed > 0) {
      return '已通知皮试'
    } else if (alreadyNoticed == 4) {
      return '重新通知皮试'
    } else if (alreadyNoticed == 1) {
      return '皮试'
    } else if (alreadyNoticed == 5) {
      return '续用'
    } else if (alreadyNoticed == 6) {
      return '免皮'
    }
  }

  return [
    {
      title: '收费类型',
      key: 'orderCategory',
      align: 'center',
      width: '5.25rem',
      render: function Element(_, m) {
        return (
          <Dropdown overlay={menu(m)} trigger={['click']}>
            <Button
              type='link'
              style={{
                color: getPayTypeColor(m.itemPayType),
                fontWeight: 'bold',
              }}
            >
              {getPayTypeName(m.itemPayType)}
              {getPayTypeName(m.itemPayType) ? <CaretDownOutlined /> : ''}
            </Button>
          </Dropdown>
        )
      },
    },
    {
      title: '序号',
      key: 'order',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => (index + 1).toString(),
    },
    {
      title: '牙位',
      key: 'toothStruct',
      width: '11.5rem',
      align: 'center',
      render: function MaterialName(_, m: Material) {
        return (
          <ToothComponents
            data={m.toothStruct}
            isEdit={false}
            onChange={(v: any, type = 0) => {
              const tooth = v.map((v: any) => (v ? v : '--'))
            }}
          />
        )
      },
    },
    {
      title: '处置信息',
      key: 'name',
      align: 'left',
      render: function MaterialName(_, m: Material) {
        let indicator = 'transparent'
        const expiredInDays = m.deadline
          ? moment.duration(moment(m.deadline).diff(moment())).asDays()
          : 9999
        if (
          m.inventoryInfo ||
          m.unShelveInfo ||
          expiredInDays <= 90 ||
          (m.skinTestTag === SkinTestStatus.Positive && m.skinTestInfo)
        ) {
          indicator = theme.e
        } else if (
          m.skinTestTag === SkinTestStatus.NeedATest &&
          m.skinTestInfo
        ) {
          indicator = theme.w
        } else if (
          (m.skinTestTag === SkinTestStatus.Continue ||
            m.skinTestTag === SkinTestStatus.Negative) &&
          m.skinTestInfo
        ) {
          indicator = theme.s
        }
        return {
          props: {
            style: {
              maxWidth: 200,
              borderLeft: `4px solid ${indicator}`,
              overflow: 'hidden',
            },
          },
          children: (
            <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Col>
                <div
                  className={styles.infoTips}
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc1,
                  }}
                >
                  {m.name}
                  {indicator !== 'transparent' && (
                    <span
                      style={{
                        fontSize: '0.875rem',
                        fontWeight: 'normal',
                      }}
                    >
                      <span
                        style={{
                          color: indicator,
                        }}
                      >
                        {m.inventoryInfo ||
                          expiredInDays <= 90 ||
                          m.unShelveInfo ||
                          m.skinTestInfo
                          ? '(' +
                          m.inventoryInfo +
                          (expiredInDays <= 90 ?
                            expiredInDays < 0 ? (`已过期`) :
                              (`有效期:${Math.floor(expiredInDays)}天 `) : '') +
                          m.unShelveInfo +
                          m.skinTestInfo +
                          ')'
                          : ''}
                        <span
                          style={{
                            display: m.skinTestState == 4 ? 'inline-block': m.skinTestState == 1 ? 'inline-block' : 'none',
                            color: m.alreadyNoticed > 0 ? '#fff' : '#000',
                            backgroundColor: m.alreadyNoticed > 0 ? '#ccc' : '#fff',
                            marginLeft: '10px',
                            fontSize: '13px',
                            border: '1px solid #ccc',
                            padding: '5px',
                            cursor: m.alreadyNoticed > 0 ? 'not-allowed' : 'pointer',
                          }}
                        >
                          {getAlreadyNoticed(m.alreadyNoticed)}
                        </span>
                      </span>
                    </span>
                  )}
                </div>
                <div
                  className={styles.mlMesssageTips}
                  style={{
                    color: m.limitType === 1 ? '#ff5d5d' : theme.tc3,
                  }}
                >
                  {getProcuctInfo(m)}
                </div>
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center', lineHeight: '32px' }}>
                {m.limitType === 1 && (
                  <Dropdown overlay={medicalMenu(m)} placement='bottomLeft'>
                    <ExclamationCircleOutlined style={{ color: '#ff5d5d' }} />
                  </Dropdown>
                )}
              </Col>
              {/* </Popover> */}
            </Space>
          ),
        }
      },
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      nextDataIndex: 'normalDose',
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '用法',
      dataIndex: 'normalUsemethod',
      align: 'center',
      width: '3.75rem',
      render: (_, m) => (m.normalUsemethod <= '0' ? '' : m.normalUsemethod),
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '4.5rem',
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '4rem',
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
    {
      title: '甲/乙',
      key: 'orderCategory',
      align: 'center',
      width: '4.25rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      align: 'center',
      title: '备注',
      key: 'remark',
      width: '6.625rem',
      ellipsis: true,
      render: (_, m) => {
        let vs
        if (m.remark) {
          if (getOtcCategoryName(m.otc)) {
            vs = [getOtcCategoryName(m.otc), m.remark]
          } else {
            vs = [m.remark]
          }
        } else {
          vs = [getOtcCategoryName(m.otc)]
        }
        return vs.join('，')
      },
    },
  ]
}

// 口腔版工作站随访表
export const WorkDisposeColumns = (
  //工作站-随访-处置记录
  theme: ThemeData,
  onSave?: (material: Material, values: Record<string, unknown>) => void,
  allowedToChangePrice = false,
  onItemChange?: (itemPayType: number, recipeItem: any) => void,
  readMode?: boolean,
  onAction?: (v: string, t: any, tooth?: string, toothType?: number) => void,
  isEdit?: boolean
): EditableColumnType<Material>[] => {

  return [
    {
      title: '牙位',
      key: 'toothStruct',
      width: '10rem',
      align: 'center',
      render: function MaterialName(_, m: Material) {
        return (
          <ToothComponents
            data={m.toothStruct}
            isEdit={isEdit}
            onChange={(v: any, type = 0) => {
              const tooth = v.map((v: any) => (v ? v : '--'))
              onAction && onAction('toothEdit', m, tooth.join('@'), type)
            }}
          />
          // 3La-B,5,6@3D-P,5O@--@2L
        )
      },
    },

    {
      title: '项目类别',
      key: 'orderCategory',
      align: 'center',
      width: '5.25rem',
      render: (_, m) => getOrderCategoryName(m.orderCategory),
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '3rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '3rem',
      colSpan: 0,
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },

    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '3.375rem',
      editable: !!onSave && allowedToChangePrice && !readMode,
      onSave: onSave,
      render: (_, m) => m.retailPrice?.toFixed(5),
    },
    {
      title: '金额',
      key: 'drugAmount',
      align: 'right',
      width: '4rem',
      render: (_, r) => r.drugAmount?.toFixed(2),
    },
  ]
}

// 口腔版 治疗计划 ->新增编辑治疗计划
export const CurePlanColumns = (
  onSave: (
    material: Material,
    values: Record<string, unknown>,
    isSaveTooth?: boolean
  ) => void,
  readMode = false,
  isEdit = true,
  isShowSave = true
): EditableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '4rem',
      render: (_1, _2, i) => `${i + 1}`,
    },
    {
      title: '牙位',
      key: 'toothStruct',
      width: '12rem',
      align: 'center',
      render: function MaterialName(_, m: Material) {
        return (
          <ToothComponents
            data={m.toothStruct}
            isShowSave={isShowSave}
            isEdit={isEdit}
            onChange={(v, type = 0) => {
              const tooth = v.map((v: any) => (v ? v : '--'))
              onSave(m, { toothStruct: tooth.join('@') }, type == 0)
            }}
          />
          // 3La-B,5,6@3D-P,5O@--@2L
        )
      },
    },
    {
      title: '项目名称',
      dataIndex: 'name',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '项目类别',
      dataIndex: 'billingCategory',
      align: 'center',
      ellipsis: true,
      width: '10rem',
      render: (_, m) => BillingCategoryName(m.billingCategory),
    },
    {
      title: '数量',
      dataIndex: 'drugCount',
      align: 'center',
      width: '5rem',
      editable: !!onSave && !readMode,
      nextDataIndex: 'normalDose',
      onSave: onSave,
      colSpan: 2,
    },
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '5rem',
      colSpan: 0,
      render: (_, m) => (m.splitTag ? m.splitUnit : m.accountUnit),
    },
    {
      title: '单价',
      dataIndex: 'retailPrice',
      align: 'right',
      width: '10rem',
      editable: !!onSave && !readMode,
      onSave: onSave,
      render: (_, m) => Number(m?.retailPrice)?.toFixed(5),
    },
  ]
}

